__turbopack_context__.v({
  "fadeIn": "BlogSearchBar-module__ev3kvG__fadeIn",
  "loadingMore": "BlogSearchBar-module__ev3kvG__loadingMore",
  "noResults": "BlogSearchBar-module__ev3kvG__noResults",
  "resultImage": "BlogSearchBar-module__ev3kvG__resultImage",
  "resultItem": "BlogSearchBar-module__ev3kvG__resultItem",
  "resultsDropdown": "BlogSearchBar-module__ev3kvG__resultsDropdown",
  "searchIcon": "BlogSearchBar-module__ev3kvG__searchIcon",
  "searchInput": "BlogSearchBar-module__ev3kvG__searchInput",
  "searchWrapper": "BlogSearchBar-module__ev3kvG__searchWrapper",
});
